<template>
<div v-if="current">
    <div>
        <playerUpgradeModal v-if="showPlayerUpgradeModal" :playerId=playerToUpgrade @closeMessage="showPlayerUpgradeModal = false" @updatePublished="upgradeValidated"></playerUpgradeModal>
        <messageModal v-if="showCreatedUpgradeMessage" message="Montées de niveau enregistrées" @closeMessage="showCreatedUpgradeMessage = false"></messageModal>
        <div class="panel-content panel-top">
            <div id="allplayers" class="row columns">
                <div id="starplayer" v-if="current.rostered_star_player" class="large-12">
                    <div class="inner-title">La Star de l'équipe : </div>
                    <table>
                        <thead class="star">
                            <tr>
                                <th width="100">Nom</th>
                                <th width="5">M</th>
                                <th width="5">F</th>
                                <th width="5">Ag</th>
                                <th width="5">Ar</th>
                                <th width="225">Compétences</th>
                                <th width="10">Réu</th>
                                <th width="10">Td</th>
                                <th width="10">Int</th>
                                <th width="10">Sor</th>
                                <th width="10">Mvp</th>
                                <th width="50">Prix</th>
                            </tr>
                        </thead>
                        <tbody class="star">
                            <tr>
                                <td>{{current.rostered_star_player.ref_star_player.name}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.M}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.F}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.Ag}}</td>
                                <td>{{current.rostered_star_player.ref_star_player.Ar}}</td>
                                <td>
                                    <span v-for="skill in current.rostered_star_player.ref_star_player.skills" >
                                            {{skill.name}},
                                    </span>
                                </td>
                                <td>{{current.rostered_star_player.nb_passes}}</td>
                                <td>{{current.rostered_star_player.nb_TD}}</td>
                                <td>{{current.rostered_star_player.nb_int}}</td>
                                <td>{{current.rostered_star_player.nb_cas}}</td>
                                <td>{{current.rostered_star_player.nb_MVP}}</td>
                                <td><span class="additional_skills">{{current.rostered_star_player.ref_star_player.cost}}k</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="regularplayers" class="large-12">
                    <div class="inner-title">Les Joueurs : </div>
                    <table>
                        <thead class="roster">
                                                 <tr>
                                                 <th width="40">N°</th>
                                                 <th width="100">Nom</th>
                                                 <th width="100">Position</th>
                                                 <th width="5">M</th>
                                                 <th width="5">F</th>
                                                 <th width="5">Ag</th>
                                                 <th width="5" v-if="current.ref_roster.ref_ruleset === 'BB_2020'">Cp</th>
                                                 <th width="5">Ar</th>
                                                 <th width="225">Compétences</th>
                                                 <th width="225">Evolutions</th>
                                                 <th width="10">Bls</th>
                                                 <th width="10">Réu</th>
                                                 <th width="10">Td</th>
                                                 <th width="10">Int</th>
                                                 <th width="10">Sor</th>
                                                 <th width="10">Mvp</th>
                                                 <th v-if="current.league.id == 1" width="10">Xp DB</th>
                                                 <th width="20">Xp</th>
                                                 <th width="50">Prix</th>
                                                 <th v-if="needAction && canPerformAction"></th>
                                                 </tr>
                                                 </thead>
                        <tbody class="roster">
                             <tr v-for="player in current.players">
                                 <td v-bind:class="{ miss: player.miss_next_game }" class="number">{{player.num}}</td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >{{player.name}}</td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >{{player.ref_roster_line}}</td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >{{player.M}}</td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >{{player.F}}</td>
                                 <template v-if="current.ref_roster.ref_ruleset === 'BB_2016'">
                                   <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ag}}</td>
                                 </template>
                                 <template v-if="current.ref_roster.ref_ruleset === 'BB_2020'">
                                   <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ag}}+</td>
                                   <td v-bind:class="{ miss: player.miss_next_game }" v-if="!player.Cp">-</td>
                                   <td v-bind:class="{ miss: player.miss_next_game }" v-else>{{player.Cp}}+</td>
                                 </template>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ar}}+</td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >
                                     <span v-for="skill in player.skills" >
                                       {{skill.name}},
                                     </span>
                                 </td>
                                 <td v-bind:class="{ miss: player.miss_next_game }" >
                                     <span v-if="player.upgrades.length" v-for="up in player.upgrades" :class="getUpgradeStyle(up)" >
                                        {{getUpgradeName(up)}},
                                     </span>
                                     <span v-if="player.downgrades" class="upgrade down">
                                        {{getDowngrades(player)}},
                                     </span>
                                     <div v-if="player.customizations && player.customizations.length" v-for="cust in player.customizations" class="upgrade stats">
                                         <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
                                     </div>
                                 </td>
                                 <td v-if="player.miss_next_game"><span class="additional_skills">Absent</span></td>
                                 <td v-else-if="player.is_journeyman" >Journalier</td>
                                 <td v-else>{{player.niggling_injuries}}</td>
                                 <td>{{player.nb_passes}}</td>
                                 <td>{{player.nb_TD}}</td>
                                 <td>{{player.nb_int}}</td>
                                 <td>{{player.nb_cas}}</td>
                                 <td>{{player.nb_MVP}}</td>
                                 <td v-if="current.league.id == 1">
                                    {{player.DB_xp}}
                                 </td>
                                 <td>{{player.total_xp}}</td>
                                 <td>
                                    <span  v-bind:class="{ miss: player.miss_next_game }" class="additional_skills">{{player.base_cost + player.evolution_cost}}k</span>
                                 </td>
                                 <td v-if="needAction && canPerformAction">
                                    <button v-if="player.need_upgrade && current.status==2" :id="player.id"
                                            @click="upgradePlayer($event)">
                                        <span :id="player.id"><i class="fa fa-arrow-up" aria-hidden="true" :id="player.id"></i></span>
                                    </button>
                                 </td>
                             </tr>
                             <tr>
                                 <td :colspan="nbColumns" class="sous-total right">
                                      <div class="row columns">
                                      <div class="large-5 columns">{{current.players.length }} Joueurs Total - {{wounded}} Absents - {{journeymens}} journalier</div>
                                      <div class="large-1 large-offset-5 columns">total</div>
                                      </div>
                                 </td>
                                 <td class="sous-total">{{playersCost}}k</td>
                             </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="stuff" class="row">
                <div class="large-5 columns large-offset-7">
                    <table>
                        <tbody class="roster">
                            <tr>
                                <td width="50"><img class="team-icon" src="/static/imgs/icons/dices.png" alt=""></td>
                                <td width="125">Relances</td>
                                <td width="110" >{{current.ref_roster.reroll_price}}k</td>
                                <td width="70">{{current.nb_rerolls}}</td>
                                <td width="150" >{{current.ref_roster.reroll_price*current.nb_rerolls}}k</td>
                            </tr>
                            <tr v-if="current.ref_roster.apo_available">
                                <td><img class="team-icon" src="/static/imgs/icons/red-cross.png" alt=""></td>
                                <td>Apothicaire</td>
                                <td>50 000</td>
                                <td v-if="current.apo">Oui</td>
                                <td v-else>Non</td>
                                <td v-if="current.apo">50k</td>
                                <td v-else>0k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/glove.png" alt=""></td>
                                <td>Popularité</td>
                                <td> - </td>
                                <td>{{current.pop}}</td>
                                <td> - </td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/coach.png" alt=""></td>
                                <td>Assistants</td>
                                <td>10k</td>
                                <td>{{current.assistants}}</td>
                                <td>{{current.assistants*10}}k</td>
                            </tr>
                            <tr>
                                <td><img class="team-icon" src="/static/imgs/icons/pom-pom.png" alt=""></td>
                                <td>Pom-pom girls</td>
                                <td>10k</td>
                                <td>{{current.cheerleaders}}</td>
                                <td>{{current.cheerleaders*10}}k</td>
                            </tr>
                            <tr>
                                <td class="sous-total right" colspan="3">Budget Annexe</td>
                                <td></td>
                                <td v-if="current.apo == false" class="sous-total">{{current.ref_roster.reroll_price*current.nb_rerolls + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td v-else class="sous-total">{{50 + current.ref_roster.reroll_price*current.nb_rerolls + current.assistants*10 + current.cheerleaders*10}} k</td>
                                <td colspan="2"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import messageModal from '../../common/message-modal.vue'
import playerUpgradeModal from '../../common/player-upgrade-modal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'team-viewer',
  components: {
    spinner,
    playerUpgradeModal,
    messageModal
  },
  props: {
    'id': Number
  },
  data () {
    return {
      showPlayerUpgradeModal: false,
      showCreatedUpgradeMessage: false,
      playerToUpgrade: null
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    nbColumns: function () {
      if (this.current.league.id === 1) {
        return 18
      }
      return 17
    },
    current: function () {
      return this.$store.getters.detailedTeam
    },
    needAction: function () {
      if (this.current.status === 2) {
        return true
      }
      return false
    },
    canPerformAction: function () {
      if (this.current.user.id === this.currentUser.id || this.currentUser.is_superuser) {
        return true
      }
      return false
    },
    wounded: function () {
      let woundedCpt = 0
      this.current.players.forEach(player => {
        if (player.miss_next_game) {
          woundedCpt++
        }
      })
      return woundedCpt
    },
    journeymens: function () {
      let journeymensCpt = 0
      this.current.players.forEach(player => {
        if (player.is_journeyman) {
          journeymensCpt++
        }
      })
      return journeymensCpt
    },
    playersCost: function (onlyPlaying = true) {
      let playerCost = 0
      this.current.players.forEach(player => {
        if (!onlyPlaying || !player.miss_next_game) {
          playerCost += (player.base_cost + player.evolution_cost)
        }
      })
      return playerCost
    }
  },
  methods: {
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 7 || upgrade.value === 8 || upgrade.value === 9 || upgrade.value === 10) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
      if (upgrade.value === 6) {
        return '+1 Cp'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + ' M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + ' F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + ' Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + ' Ar '
      }
      if (player.downgrades['Cp'] !== 0) {
        dwngrd += '-' + player.downgrades['Cp'].toString(10) + ' Cp '
      }
      return dwngrd
    },
    getRosterIcon (item) {
      return '/static/imgs/team-icons/' + item.ref_roster.name + '.png'
    },
    upgradeValidated () {
      this.$store.dispatch('getDetailedTeam', this.current.id.toString())
      this.showCreatedUpgradeMessage = true
      this.showPlayerUpgradeModal = false
    },
    upgradePlayer ($event) {
      this.playerToUpgrade = $event.target.id
      this.showPlayerUpgradeModal = true
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}

.star tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: #E9EDEF;

}

.roster tr td.sous-total{
    font-weight: 600;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{
  margin-right: 0;
  padding-right:0;
  text-align: right;
}

button.row{
    margin-left: 0.4rem;
}

.panel-top {
    padding-top: 0rem;
}

.miss {
    text-decoration: line-through;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.upgrade {
  font-weight: 600;
}

.base {
  color: #1a6b3a
}

.simple {
  color: #000000
}

.double {
  color: #0e648e
}

.stats {
  color: #882e8e
}

.down {
  color: #8e2625
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// regular-team-viewer.vue?cfd883ce